import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  open() {
    this.drawerTarget.open = true
  }

  close() {
    this.drawerTarget.open = false
  }
}
